<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- Unidade -->
                <div class="md:col-span-5">
                  <BaseInput
                    type="text"
                    name="unidadeForm.unidade"
                    v-model="store.unidadeForm.unidade"
                    :info="'Unidade'"
                    label="Informe a unidade"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.unidadeForm.unidade = undefined"
                      />
                    </template>
                  </BaseInput>

                  <span name="unidadeForm.unidade" class="text-red-600 text-sm" />
                </div>

                <!-- cidade -->
                <div class="md:col-span-3">
                  <BaseInput
                    type="text"
                    name="unidadeForm.cidade"
                    v-model="store.unidadeForm.cidade"
                    :info="'Cidade'"
                    label="Informe a cidade"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.unidadeForm.cidade = undefined"
                      />
                    </template>
                  </BaseInput>

                  <span name="unidadeForm.cidade" class="text-red-600 text-sm" />
                </div>

                <!-- estado -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="text"
                    name="unidadeForm.estado"
                    v-model="store.unidadeForm.estado"
                    :info="'Estado'"
                    label="Estado"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.unidadeForm.estado = undefined"
                      />
                    </template>
                  </BaseInput>

                  <span name="unidadeForm.estado" class="text-red-600 text-sm" />
                </div>
              </div>

            </div>
          </div>
          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { PhCloudArrowUp, PhFileArrowUp } from '@phosphor-icons/vue'
import { docType } from '../lookups/form'
import { dataRcd } from '../store'

export default ({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput
  },
  props: {
    descriptionTitle: String
  },
  data () {
    return {
      PhFileArrowUp,
      PhCloudArrowUp,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataRcd.state,
      dataRcd,
      docType
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        this.selectedFileName = file.name
        this.selectedFileUrl = URL.createObjectURL(file)

        this.store.form.docName = this.selectedFileName
        this.store.form.doc = file
      }
    }
  }
})
</script>
